import styled from "styled-components";

export const PageHeaderButtonContainer = styled.div`
    display: flex;

    margin-left: 12px;
    height: 100%;
    width: auto;
`;